import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

import ChatApi from 'mewe/api/chat-api';
import ChatStore from 'mewe/stores/chat-store';
import dispatcher from 'mewe/dispatcher';
import { installDropdown } from 'mewe/utils/dropdown-utils';

export default class MwChatRequestSettings extends Component {
  @tracked dropdownOptions;

  constructor() {
    super(...arguments);

    installDropdown(this, 'dropdownOptions');
  }

  @action
  ignoreAllRequests() {
    ChatApi.ignoreAllChatRequests();
    ChatStore.send('setAllChatRequestsAsRead');
  }

  @action
  deleteAllRequests() {
    dispatcher.dispatch('chat', 'closeSmallChat', this.args.thread);
    ChatApi.deleteAllChatRequests();
    ChatStore.send('deleteAllChatRequests');
  }

  @action
  turnOnChatRequests() {
    dispatcher.dispatch('chat', 'showTurnOnChatRequestsPrompt');
  }

  @action
  turnOffChatRequests() {
    dispatcher.dispatch('chat', 'showTurnOffChatRequestsPrompt');
  }
}
